const createHash = (data: unknown): string => {
  const toStableValue = (obj: unknown): string => {
    // Handle primitives/null/undefined
    if (obj === undefined || obj === null) return "";

    if (typeof obj !== "object") {
      return String(obj);
    }

    // Handle Arrays
    if (Array.isArray(obj)) {
      return JSON.stringify(obj.map(item => toStableValue(item)));
    }

    // Handle Objects (Sort keys to ensure stability: {a:1, b:2} == {b:2, a:1})
    // We cast to Record<string, unknown> because we confirmed it's an object above
    const sortedObj = Object.keys(obj as Record<string, unknown>)
      .sort()
      .map(key => {
        const val = (obj as Record<string, unknown>)[key];
        return `${key}:${toStableValue(val)}`;
      });

    return `{${sortedObj.join(",")}}`;
  };

  return toStableValue(data);
};

export default createHash;
